module.exports = __webpack_public_path__ + "static/media/taskTimer1.e257bd70.png";